const {getAsset} = require("utils");

const colors =
{
	BLUE: "#10A3D9",
	PINK: "#E73657",
	GREEN: "#8CC740",
	YELLOW: "#F2CA22",
};

module.exports =
{
	title: "Piper",
	website: "https://www.buildpiper.com/",
	slogan: "The computer that prepares kids for a lifetime of building technology",
	sections:
	[
		{
			image: "https://cdn.shopify.com/s/files/1/0925/6256/t/67/assets/building_beginning-compressor.jpg",
			//image: getAsset("projects/pipercode/splash.jpg"),
		},
		{
			title: "What is Piper?",
			body:
			`Piper is a company that teaches kids to build electronics and now code. They sell a kit
			that comes with a Raspberry Pi, a monitor, and various electronics items such as a breadboard, wires, buttons, and LEDs.`,
		},
		{
			title: "The Problem",
			color: colors.PINK,
			body:
			`I became a part of the Piper team to fill a gap in their team. They needed someone specialized in web technologies but also capable
			of solving general computing and logistical problems. Throughout my time at Piper I worked on almost a <strong>dozen projects</strong>,
			including fixing their Toy Time Machine webite, designing and implementing an admin interface panel and REST API for kids to share their
			favorite sounds, videos, and pictures from Piper, creating an analytics dashboard to view aggregated data, implementing a Twitter growth
			marketing AI bot, serving as a core developer for PiperCode, a Blockly-based coding IDE for kids, and managing and optimizing
			their main website.`,
		},
		/*{
			title: "Piper Universe",
			body:
			``,
		},*/
		{
			image: getAsset("projects/piper/analytics.png"),
		},
		{
			title: "Analytics",
			color: colors.YELLOW,
			body:
			`The analytics dashboard provides a <strong>REST API</strong> for developers to send data to and a website to view key statistics.
			Included are breakdowns of user play time including what levels they spend their time on the most and the average amount of time between
			their sessions. A <strong>key difficulty</strong> in creating the dashboard was migrating their old, raw data to fit the new
			database structure. In the case of figuring out how long users' sessions were, the old data didn't have the fields that
			made this calculation simple, so I used level start and end times to determine how long a user's session was. To account for users
			who played multiple levels in one session, I set a time interval in which playing another level will be considered as part of
			the previous session. The dashboard provides the Piper team with raw data and filtered graphs to help them make informed
			decisions.`,
		},
		{
			title: "Website Management",
			color: colors.GREEN,
			body:
			`While at Piper, I also spent a lot of my time managing their website. I collaborated with several designers at Piper to ensure the
			new website designs were properly translated from images to tangible HTML and CSS. Often when doing this, the designer's image of
			the final result of the website isn't what they expect due to screen size expectations, so we worked together to create versions that
			were both responsive and functional. One the most interesting self-projects I did on the website was the integration of a live, dynamic
			Instagram feed on the home page. The feed featured posts that my algorithm automatically selected and only explicitly approved posts
			were randomly selected to appear on the website. This feature added liveliness to the website in that it showed real people using Piper
			and enjoying it. Another key thing I did for the website was <strong>optimization</strong>. I did deep analyses on the website including
			<strong>YSlow</strong>, <strong>Google PageSpeed</strong>, and looking at the <strong>asset waterfall charts</strong>. After several days
			of rigorous compressing of all images on the website, removing unused analytics code, and properly minifying assets, I <strong>reduced the
			page load time by 90%</strong> and enhanced the <strong>critical rendering path</strong>.`,
		},
		/*{
			title: "Minetest",
			body:
			``,
		},*/
		{
			image: getAsset("projects/piper/ai.jpg"),
		},
		{
			title: "Piper Social",
			color: colors.BLUE,
			body:
			`A highly customizable, modular system that uses the Twitter API extensively, both for manual requests and parsing
			their <strong>Firehose API</strong>. The system comes with an admin dashboard for the Piper marketing team to adjust various settings.
			These settings include phrases, hashtags, users, and events bound to specific tweets that can trigger when a tweet is liked or retweeted.
			The system constantly processes data acquired from Twitter using the Firehose API.

			Piper Social can <strong>like and retweet posts automatically, follow people who tweet, search for phrases in users' biographies,
			and even respond to tweets</strong>. The biggest challenge in creating Piper Social was its modularity. I wanted to keep all of the functions
			separate from one another to make it easier to come back and make changes. Another challenge I overcame was deploying the system from
			my local computer, which I used for testing and development, to an Ubuntu server and configure all of the CRON jobs, ports, permissions,
			and to establish a permanent Firehose API connection that restarted automatically and could be controlled manually in the dashboard.`,
		},
		{
			image: getAsset("projects/pipercode/cover-chromatic.jpg"),
		},
		{
			title: "PiperCode",
			link: ["Visit Website", "https://www.buildpiper.com/pages/pipercode"],
			color: colors.PINK,
			body:
			`PiperCode is Piper's first step to <strong>teaching kids how to code</strong>. It's a coding program based on blocks that lets kids interact with the
			Raspberry Pi. It comes with tutorial projects that restrict the blocks kids can use and shows kids pictures and videos that they can follow
			to build advanced programs. One such example is a Beat the Buzzer game in which kids hook up an LED and a button to the breadboard and the
			LED lights up at a random time. The kids win by pressing the button while the light is on. The best part of this tutorial is that kids build
			the program themselves. They connect the blocks and see the logic of the execution. Beyond the tutorials, kids can create custom projects
			without any restrictions and can come up with amazing ways to learn and entertain themselves. When I started PiperCode, there was already a
			very bare-bones prototype written in AngularJS but I was prompted to convert it to React before adding all of the features. I had never used
			React before, so I had to figure out this gigantic library and come up with a way to organize all of the application's components. It was
			difficult but I knew that in the long run, it would pay off greatly. I was responsible for implementing all of the back-end logic and
			converting the design documents into working front-end components. I also had to write unit tests and ensure compatibility with the
			Raspberry PI. After three months and a bit of refactoring, PiperCode now ships on over 10,000 Piper kits and is my proudest coding
			achievement.`,
		}
	],
};


// WEBPACK FOOTER //
// ./src/js/cases/Piper.js